import { render, staticRenderFns } from "./HeaderContent.vue?vue&type=template&id=1865490a&scoped=true"
var script = {}
import style0 from "./HeaderContent.vue?vue&type=style&index=0&id=1865490a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1865490a",
  null
  
)

export default component.exports